interface FooterProps {
  onBookCall?: () => void;
}

const Footer = (_props: FooterProps) => {
  return (
    <footer className="bg-charcoal text-white">
      <div className="max-w-7xl mx-auto px-6 py-14 flex flex-col items-center gap-4 text-center">
        <img
          src="https://public.readdy.ai/ai/img_res/371b58ef-9b22-4c45-8493-dbb40c63d635.png"
          alt="Blue Digital AI"
          className="w-[150px] h-[150px] object-contain"
        />
        <p className="text-sm text-white/60 leading-relaxed max-w-xs">
          AI-powered systems that capture, qualify, and convert your leads — so your business operates without gaps.
        </p>
        <p className="text-xs text-white/40 mt-2">
          &copy; {new Date().getFullYear()} Blue Digital AI. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
